// Enum baseado no DTO fornecido
export enum HotelExperienceType {
  ROMANCE = 'romance',
  MEMORIES = 'memories',
  GASTRONOMY = 'gastronomy',
  WELLNESS = 'wellness',
  ADVENTURE = 'adventure',
  CULTURAL = 'cultural',
}

export type HotelExperienceTypeFormatted = {
  id: number
  pluginSpaceId: number
  title: string
  description: string
  price: number
  duration: string
  includes: string[]
  type: HotelExperienceType
  rating?: number
  image?: string
  status?: boolean
  createdAt?: string
  updatedAt?: string
  // Campos formatados para exibição
  typeLabel: string
  priceFormatted: string
  statusLabel: string
  shortDescription: string
  ratingFormatted: string
  includesFormatted: string
}

export type CreateHotelExperienceDto = {
  title: string
  description: string
  price: number
  titleFreePrice?: string | null
  duration: string
  includes: string[]
  type: HotelExperienceType
  rating?: number
  image?: string
  status?: boolean
}

export type UpdateHotelExperienceDto = {
  title?: string
  description?: string
  price?: number
  titleFreePrice?: string | null
  duration?: string
  includes?: string[]
  type?: HotelExperienceType
  rating?: number
  image?: string
  status?: boolean
}

// Funções utilitárias para labels
export const getTypeLabel = (type: HotelExperienceType): string => {
  const typeLabels: Record<HotelExperienceType, string> = {
    [HotelExperienceType.ROMANCE]: 'Romance',
    [HotelExperienceType.MEMORIES]: 'Memórias',
    [HotelExperienceType.GASTRONOMY]: 'Gastronomia',
    [HotelExperienceType.WELLNESS]: 'Bem-estar',
    [HotelExperienceType.ADVENTURE]: 'Aventura',
    [HotelExperienceType.CULTURAL]: 'Cultural',
  }
  return typeLabels[type] || type
}

export const getTypeColor = (type: HotelExperienceType): string => {
  const colors: Record<HotelExperienceType, string> = {
    [HotelExperienceType.ROMANCE]: 'danger',
    [HotelExperienceType.MEMORIES]: 'info',
    [HotelExperienceType.GASTRONOMY]: 'warning',
    [HotelExperienceType.WELLNESS]: 'success',
    [HotelExperienceType.ADVENTURE]: 'primary',
    [HotelExperienceType.CULTURAL]: 'secondary',
  }
  return colors[type] || 'primary'
}
